<template>
  <PageLayout
    class="create-work"
    :title="languages.creatework_headerTitle"
    :leftArrow="!hideBackBtn"
    :clickLeft="back"
  >
    <UserHeader
      :roleName="userInfo.roleName || workForm.roleName"
      :gameName="userInfo.gameName || workForm.gameName"
      :serverName="userInfo.serverName || workForm.serverName"
    ></UserHeader>
    <van-form
      class="form"
      ref="formRef"
      @submit="beforeSubmit"
      @failed="validFailed"
    >
      <template v-if="canSelectGameInfo">
        <van-field class="form-item">
          <template #label>
            <em class="form-item-icon iconfont icon-game"></em>
          </template>
          <template #input>
            <Select
              v-model="workForm.gameId"
              :disabled="disabledGameSelect"
              :placeholder="languages.creatework_gameHolder"
              @change="changeSelectGame"
            >
              <option
                v-for="item in optionsGame"
                :value="item.ID"
                :key="item.ID"
              >
                {{ item.NAME }}
              </option>
            </Select>
          </template>
        </van-field>
        <van-field class="form-item">
          <template #label>
            <em class="form-item-icon iconfont icon-server"></em>
          </template>
          <template #input>
            <Select
              v-model="workForm.serverId"
              :placeholder="languages.creatework_serverHolder"
              :disabled="disabledServerSelect"
              @change="changeSelectServer"
            >
              <option
                v-for="item in optionsServer"
                :value="item.SID"
                :key="item.SID"
              >
                {{ item.REAL_NAME }}
              </option>
            </Select>
          </template>
        </van-field>
        <van-field v-if="showRoleSelect" class="form-item">
          <template #label>
            <em class="form-item-icon iconfont icon-user"></em>
          </template>
          <template #input>
            <Select
              v-model="workForm.roleId"
              :placeholder="languages.creatework_roleHolder"
              @change="changeSelectRole"
            >
              <option
                v-for="item in optionsRole"
                :value="item.roleID"
                :key="item.roleID"
              >
                {{ item.roleName }}
              </option>
            </Select>
          </template>
        </van-field>
      </template>
      <van-field class="form-item" v-model="workForm.workType" name="workType">
        <template #label>
          <em class="form-item-icon iconfont icon-work"></em>
        </template>
        <template #input>
          <Select
            v-model="workForm.workType"
            :placeholder="optionsWorkType.placeholder"
          >
            <option
              v-for="(item, index) in optionsWorkType.options"
              :value="index"
              :key="index"
            >
              {{ item }}
            </option>
          </Select>
        </template>
      </van-field>
      <van-field
        class="form-item"
        v-model="workForm.workTitle"
        name="workTitle"
        :clearable="true"
        :placeholder="languages.creatework_titleHolder"
      >
        <template #label>
          <em class="form-item-icon iconfont icon-work"></em>
        </template>
      </van-field>
      <van-field
        class="form-item form-item-textarea"
        v-model="workForm.workDetail"
        name="workDetail"
        rows="6"
        autosize
        type="textarea"
        maxlength="600"
        :placeholder="languages.creatework_detail"
        show-word-limit
        :clearable="true"
      />
      <van-field
        v-if="canUseUpload"
        class="form-item form-item-image"
        name="workImages"
        :center="true"
      >
        <template #input>
          <van-uploader
            v-model="workFileArr"
            :accept="accept"
            :max-count="maxCount"
            :before-read="beforeRead"
            :after-read="afterRead"
            :preview-options="{
              closeable: true
            }"
            :before-delete="beforeDelete"
          >
            <template #preview-cover="{ customerType, url, duration }">
              <UploadVideoPreview
                v-if="customerType === 'video'"
                :firstFrameImage="url"
                :duration="duration"
              ></UploadVideoPreview>
            </template>
          </van-uploader>
          <IosUploadIcon
            v-if="showIOSUpload"
            @click="iosUpload"
          ></IosUploadIcon>
        </template>
      </van-field>
      <p class="tip" v-if="canUseUpload">
        {{ languages.creatework_uploadTips }}
      </p>
      <template v-if="isLogin && !hideEmail">
        <p class="tip tip-email">{{ languages.serviceWillReply }}</p>
        <van-field
          class="form-item"
          v-model="email"
          name="email"
          :clearable="true"
          :placeholder="languages.inputValidEmail"
          :disabled="!!recordBindEmail"
        />
      </template>
      <div class="form-item-submit">
        <van-button
          class="btn"
          round
          block
          type="info"
          native-type="submit"
          :loading="loadingSubmit"
        >
          <template #icon>
            <em class="btn-icon iconfont icon-info"></em>
          </template>
          <template>{{ languages.submit }}</template>
        </van-button>
      </div>
    </van-form>
    <EmailSubscribe
      ref="emailSheetRef"
      v-model="visibleEmailSubscribeSheet"
      :email="email"
      :loadingSubmit="loadingSubmit"
      :submitTip="languages.confirmCanSubmit"
      :submitSuccessTip="submitSuccessTip"
      @submit="submit"
      @closed="closedSuccessSheet"
    ></EmailSubscribe>
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import UserHeader from '@components/officialSupport/UserHeader.vue';
import Select from '@components/officialSupport/common/Select.vue';
import EmailSubscribe from '@components/officialSupport/EmailSubscribe.vue';
import UploadVideoPreview from '@components/officialSupport/UploadVideoPreview.vue';
import emailSubscribe from '@mixins/officialSupport/emailSubscribe.js';
import fileUpload from '@mixins/officialSupport/fileUpload.js';
import IosUploadIcon from '@components/officialSupport/IosUploadIcon.vue';
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import globalConfig from '@utiles/globalConfig';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import { aiBotAppId } from '@mixins/officialSupport/aiBot';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { getOrderSourceParams } from '@utiles/officialSupport';
import bridge from '@utiles/bridge';
const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;
export default {
  name: 'CreateWork',
  mixins: [emailSubscribe, fileUpload, pointStayTime, iframeMessage],
  data() {
    return {
      loadingPage: false, // 页面加载中
      showEmailConfirm: false, // 是否显示邮箱确认
      visibleSheet: false, // 是否显示底部提示框
      // 下拉列表
      optionsGame: [],
      disabledGameSelect: false,
      disabledServerSelect: false,
      optionsServer: [],
      optionsRole: [],
      // 表单元素
      workForm: {
        gameId: undefined,
        gameName: undefined,
        serverId: undefined,
        serverName: undefined,
        roleId: undefined,
        roleName: undefined,
        workType: undefined,
        workTitle: undefined,
        workDetail: undefined
      },
      email: undefined, // 绑定的邮箱
      timer: null,
      submitSucc: false,
      hideBackBtn
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.creatework,
      urlParams: state => state.urlParams,
      isUidLogin: state => Number(state.urlParams.isUidLogin) === 1,
      isUidGame: state => state.isUidGame,
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      isIframe: state => state.isIframe,
      hideEmail: state => state.hideEmail,
      isJumpAiBot: state => state.isJumpAiBot,
      curLang: state => state.curLang,
      isSpecialDifyUser: state => state.isSpecialDifyUser
    }),
    ...mapGetters(['canSelectGameInfo']),
    // 是否显示角色选择
    showRoleSelect() {
      if (
        !this.isUidLogin ||
        !this.isUidGame ||
        (this.isUidGame && !this.urlParams.uid)
      ) {
        return this.isLogin;
      } else {
        return true;
      }
    },
    optionsWorkType() {
      return {
        placeholder: this.letter?._selectBox?.selectTile || '',
        options: this.letter?._selectBox?.selectList || []
      };
    }
  },
  methods: {
    ...mapActions([
      'getGameList',
      'getServerList',
      'getCharName',
      'createWork'
    ]),
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/mylist');
      } else {
        this.$router.go(-1);
      }
    },
    // 初始化游戏信息
    initGameInfo() {
      if (!this.canSelectGameInfo) {
        // 初始化表单信息
        this.workForm.gameId = this.urlParams.gameId;
        this.workForm.serverId = this.urlParams.serverId;
      } else if (this.urlParams.gameId) {
        // 如果只有游戏ID那么获取到游戏列表后给它选上且不能切换游戏
        this.loadGameOptions(this.urlParams.gameId);
      } else {
        // 如果连游戏ID都没有，那就获取游戏列表，可以切换游戏
        this.loadGameOptions();
      }
      return Promise.resolve();
    },
    // 获取游戏列表
    async loadGameOptions(gameId) {
      try {
        const data = await this.getGameList(gameId || '');
        if (data && data?.length && data.length > 0) {
          if (gameId && data[0]?.ID == gameId) {
            const defGameId = String(data[0]?.ID);
            this.loadServerOptions(defGameId);
            this.workForm.gameId = defGameId;
            this.workForm.gameName = data[0]?.NAME;
            this.disabledGameSelect = true;
          }
          this.optionsGame = data;
        } else {
          this.optionsGame = [];
          this.$toast(this.languages.creatework_noGame);
        }
        return Promise.resolve();
      } catch (error) {
        console.log(error);
        this.disabledGameSelect = false;
        this.optionsGame = [];
        this.$toast(this.languages.creatework_noGame);
        return Promise.reject();
      }
    },
    // 获取服务器列表
    async loadServerOptions(gameId) {
      try {
        const data = await this.getServerList(gameId);
        if (data && data?.length && data.length > 0) {
          if (data.length == 1) {
            this.workForm.serverId = data[0]?.SID;
            this.workForm.serverName = data[0]?.REAL_NAME;
            this.loadRoleOptions(gameId, data[0]?.SID);
          }
          this.optionsServer = data;
        } else {
          this.optionsServer = [];
          this.$toast(this.languages.creatework_noServer);
        }
        return Promise.resolve();
      } catch (error) {
        console.log(error);
        this.optionsServer = [];
        this.$toast(this.languages.creatework_noServer);
        return Promise.reject();
      }
    },
    // 获取角色列表
    async loadRoleOptions(gameId, serverId) {
      try {
        this.disabledServerSelect = true;
        const data = await this.getCharName({
          gameId,
          serverId
        });
        if (data && data?.length && data.length > 0) {
          if (data.length == 1) {
            this.workForm.roleId = data[0]?.roleID;
            this.workForm.roleName = data[0]?.roleName;
          }
          this.optionsRole = data;
        } else {
          this.optionsRole = [];
          this.$toast(this.languages.creatework_noRole);
        }
        // this.disabledServerSelect = false;
        return Promise.resolve();
      } catch (error) {
        console.log(error);
        this.optionsRole = [];
        this.$toast(this.languages.creatework_noRole);
        // this.disabledServerSelect = false;
        return Promise.reject();
      } finally {
        this.disabledServerSelect = false;
      }
    },
    // 是否展示底部弹窗
    switchVisibleSheet(bool) {
      this.visibleSheet = bool;
    },
    // 是否显示邮箱二次确认
    switchShowEmailConfirm(bool) {
      this.showEmailConfirm = bool;
    },
    // 表单校验失败
    validFailed({ values, errors }) {
      console.log(values, errors);
    },
    getSubmitParams() {
      const imageFileArr =
        this.workFileArr?.filter(
          item => item.customerType === 'image' && item.status === 'done'
        ) || [];
      const videoFileArr =
        this.workFileArr?.filter(
          item => item.customerType === 'video' && item.status === 'done'
        ) || [];
      return {
        category_id: this.workForm.workType
          ? Number(this.workForm.workType) + 1
          : undefined,
        character_name: this.userInfo.roleName || this.workForm.roleName,
        game_id: this.workForm.gameId,
        game_server_id: this.workForm.serverId,
        message: this.workForm.workDetail,
        package_version: this.urlParams.packageVersion,
        pic: JSON.stringify(imageFileArr.map(item => item.url)),
        pic_compress: JSON.stringify(imageFileArr.map(item => item.isCompress)),
        videoPath: JSON.stringify(videoFileArr.map(item => item.videoPath)),
        videoPreviewPic: JSON.stringify(videoFileArr.map(item => item.url)),
        videoDurations: JSON.stringify(videoFileArr.map(item => item.duration)),
        picAndVideoSequence: JSON.stringify(
          this.workFileArr.map(item => {
            const url =
              item.customerType === 'image' ? item.url : item.videoPath;
            return url?.split('/')?.pop();
          })
        ),
        subject: this.workForm.workTitle,
        frontVersion: `v1_${new Date().getTime()}`,
        isOpenAiEntrance: this.isJumpAiBot,
        isIframe: this.isIframe,
        pageSource: this.$route.query.source || '',
        is_special_dify_user: this.isSpecialDifyUser,
        front_url: window.location.href,
        ...getOrderSourceParams()
      };
    },
    async beforeSubmit(_values) {
      clickButton({
        btnName: 'clickSubmitOrder',
        locationKey: locationType.orderCreatePage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: this.isJumpAiBot,
          isLogin: this.isLogin
        }
      });
      if (!this.recordBindEmail && this.email) {
        if (this.email) {
          let validEmailRes = false;
          validEmailRes = this.validEmail();
          if (!validEmailRes) return;
        }
        this.$refs.emailSheetRef.showEmailConfirm();
      } else {
        await this.submit();
      }
    },
    async checkCanSubmit() {
      return new Promise(async resolve => {
        if (this.isIframe) {
          resolve();
          return;
        }
        const gameId =
          this.workForm?.gameId ||
          globalConfig.getHrefParam('game_id') ||
          globalConfig.getHrefParam('gameId');
        if (!gameId) {
          window.csorderDataLayer.push({
            eventName: 'no_game_id',
            eventValue: {
              frontVersion: `v1_${new Date().getTime()}`,
              isOpenAiEntrance: this.isJumpAiBot,
              isLogin: this.isLogin,
              isIframe: this.isIframe
            }
          });
          resolve();
          return;
        }
        const serverId =
          this.workForm?.serverId ||
          globalConfig.getHrefParam('server_id') ||
          globalConfig.getHrefParam('serverId');
        await this.$store.dispatch('checkJumpAiBot', {
          game_id: gameId,
          server_id: serverId
        });
        if (this.isJumpAiBot) {
          if (this.isSpecialDifyUser == 1) {
            window.csorderDataLayer.push({
              eventName: 'special_dify_user_go_create_commer_order',
              eventValue: {
                frontVersion: `v1_${new Date().getTime()}`,
                isOpenAiEntrance: this.isJumpAiBot,
                isLogin: this.isLogin,
                isIframe: this.isIframe
              }
            });
            resolve();
            return;
          }
          window.csorderDataLayer.push({
            eventName: 'redirect_jump_ai_bot',
            eventValue: {
              frontVersion: `v1_${new Date().getTime()}`,
              isOpenAiEntrance: this.isJumpAiBot,
              isLogin: this.isLogin,
              isIframe: this.isIframe
            }
          });
          this.jumpAiBot();
          return;
        }
        resolve();
      });
    },
    async submit() {
      this.loadingSubmit = true;
      await Promise.all(this.workFileArr.map(item => item.uploadingPromise));
      const submitWorkParams = this.getSubmitParams();
      if (!this.recordBindEmail && this.email) {
        await this.submitBindEmail();
      }
      try {
        await this.checkCanSubmit();
        const res = await this.createWork(submitWorkParams);
        const insertId = res?.data?.data?.insertId || '';
        window.csorderDataLayer.push({
          eventName: 'submit_order',
          eventType: this.workForm.workType
            ? Number(this.workForm.workType) + 1
            : '',
          eventValue: {
            orderId: insertId,
            orderType: 'normal',
            frontVersion: `v1_${new Date().getTime()}`,
            isOpenAiEntrance: this.isJumpAiBot,
            isLogin: this.isLogin,
            isIframe: this.isIframe
          }
        });
        this.submitSuccessTip = res?.msg || '';
        if (this.isIframe) {
          window.csorderDataLayer.push({
            eventName: 'send_to_iframe',
            eventValue: {
              orderId: insertId,
              orderType: 'normal',
              frontVersion: `v1_${new Date().getTime()}`,
              isOpenAiEntrance: this.isJumpAiBot,
              isLogin: this.isLogin,
              isIframe: this.isIframe
            }
          });
          this.postMessageToParent('createWorkSucc', {
            orderId: insertId
          });
        }
        this.$refs.emailSheetRef.showEmailSubscribeSucc();
        this.submitSucc = true;
        this.timer = setTimeout(() => {
          this.$refs?.emailSheetRef?.close();
        }, 3000);
      } catch (error) {
        console.log(error);
        this.$refs?.emailSheetRef?.close();
      }
      this.loadingSubmit = false;
    },
    resetForm() {
      this.workForm.workType = undefined;
      this.workForm.workTitle = undefined;
      this.workForm.workDetail = undefined;
      this.workFileArr = [];
    },
    closedSuccessSheet() {
      if (this.submitSucc) {
        clearTimeout(this.timer);
        this.submitSucc = false;
        this.resetForm();
        this.$router.push('/mylist');
      }
    },
    changeSelectGame(gameId) {
      this.loadServerOptions(gameId);
      this.optionsServer = [];
      this.optionsRole = [];
      this.workForm.serverId = undefined;
      this.workForm.serverName = undefined;
      this.workForm.roleId = undefined;
      this.workForm.roleName = undefined;
      this.workForm.gameName =
        this.optionsGame?.find(item => item.ID == gameId)?.NAME || '';
    },
    changeSelectServer(serverId) {
      if (this.showRoleSelect) {
        this.loadRoleOptions(this.workForm.gameId, serverId);
      }
      this.optionsRole = [];
      this.workForm.roleId = undefined;
      this.workForm.roleName = undefined;
      this.workForm.serverName =
        this.optionsServer?.find(item => item.SID == serverId)?.REAL_NAME || '';
    },
    changeSelectRole(roleId) {
      this.workForm.roleName =
        this.optionsRole?.find(item => item.roleID == roleId)?.roleName || '';
    },
    jumpAiBot() {
      const aiBotLink = getGlobalGetGotoLink({
        link: `https://gsupport.${globalConfig.getMainHost()}/smartChat/aibot?gameId=${
          this.workForm?.gameId || ''
        }&serverId=${this.workForm?.serverId || ''}&roleId=${
          this.workForm?.roleId || globalConfig.getHrefParam('roleId') || ''
        }&roleName=${
          this.userInfo?.roleName || this.workForm?.roleName || ''
        }&language=${this.curLang}`
      });
      if ([386].includes(+this.workForm?.gameId) && bridge.runInsdk()) {
        bridge.callSdkMethod('openWebView', {
          url: aiBotLink,
          loginDir: 1,
          appendParams: 1,
          pageOrientation: 1
        });
        return;
      }
      window.location.href = aiBotLink;
    }
  },
  async created() {
    this.loadingPage = true;
    this.initGameInfo();
    window.csorderDataLayer.push({
      eventName: 'view_normal_order',
      eventType: '',
      eventReason: this.$route.query.source || ''
    });
    this.loadingPage = false;

    // DEV:批量生成假数据
    // for (let i = 0, len = 100; i < len; i++) {
    //   const submitWorkParams = {
    //     category_id: 1,
    //     character_name: this.userInfo.roleName,
    //     game_id: this.workForm.gameId,
    //     game_server_id: this.workForm.serverId,
    //     message:
    //       Math.random().toString(32).substr(2) +
    //       Math.random().toString(32).substr(2) +
    //       Math.random().toString(32).substr(2),
    //     package_version: this.urlParams.packageVersion,
    //     pic: JSON.stringify(this.workFileArr.map(item => item.url)),
    //     pic_compress: JSON.stringify(
    //       this.workFileArr.map(item => item.isCompress)
    //     ),
    //     subject:
    //       Math.random().toString(32).substr(2) +
    //       Math.random().toString(32).substr(2)
    //   };
    //   await this.createWork(submitWorkParams);
    // }
  },
  components: {
    PageLayout,
    UserHeader,
    Select,
    EmailSubscribe,
    UploadVideoPreview,
    IosUploadIcon
  }
};
</script>

<style lang="scss" scoped>
.create-work {
  padding-bottom: 40px;
  .form {
    box-sizing: border-box;
    max-width: 92%;
    width: 382px;
    margin: 18px auto 20px;
    &-item {
      margin-bottom: 18px;
      border-radius: 6px;
      font-size: 16px;
      line-height: 44px;
      background-color: var(--block-bg-light-color);

      &::after {
        display: none;
      }

      &-icon {
        font-size: 22px;
        color: var(--main-color);
      }

      &-textarea {
        line-height: inherit;
      }

      &-image {
        padding: 0;
        margin-bottom: 0;
        background-color: transparent;

        ::v-deep .van-field__control {
          flex-wrap: wrap;
        }

        ::v-deep .van-uploader__preview,
        ::v-deep .van-uploader__upload {
          overflow: hidden;
          background-color: var(--block-bg-light-color);
          border-radius: 6px;
        }

        ::v-deep .van-loading__spinner {
          vertical-align: baseline;
        }

        ::v-deep .van-uploader__upload-icon {
          color: var(--main-color);
        }
      }

      &-submit {
        margin-top: 18px;

        .btn {
          width: 234px;
          height: 50px;
          margin: auto;
          border-color: var(--main-color);
          background: var(--main-color);
          box-shadow: 0px 0px 14px 0px var(--main-color);
          border-radius: 6px;
          font-size: 18px;
          &-icon {
            font-size: 24px;
          }
        }
      }

      ::v-deep .van-field__label {
        width: 24px;
      }

      ::v-deep .van-field__control {
        color: var(--text-color);
      }
    }
  }
  .tip {
    font-size: 12px;
    line-height: 14px;
    color: var(--placeholder-color);

    &-email {
      margin-top: 36px;
      margin-bottom: 10px;
    }
  }
  .selector {
    background-color: var(--block-bg-light-color);

    ::v-deep .van-picker-column__item {
      color: var(--text-color);
    }
  }
}
</style>
